import { fetchPrivateApi } from '@/lib/api/apiServiceBase.ts';
import {
  CostCategoryDto,
  CostCategoryUsageDto,
} from '@/features/dashboard/costCategories/types/CostCategoryDto.ts';
import { CostCategoryRequest } from '@/features/dashboard/costCategories/types/CostCategoryRequest.ts';

const costCategoriesApi = {
  /** Płaska lista, bez paginacji. Pominięty `archived` = wszystkie kategorie. */
  getAll: async (archived?: boolean): Promise<CostCategoryDto[]> => {
    const params =
      archived === undefined ? '' : `?archived=${String(archived)}`;
    return await fetchPrivateApi<CostCategoryDto[]>(
      'GET',
      `cost-categories${params}`,
    );
  },

  getUsage: async (id: string): Promise<CostCategoryUsageDto> => {
    return await fetchPrivateApi<CostCategoryUsageDto>(
      'GET',
      `cost-categories/${id}/usage`,
    );
  },

  create: async (dto: CostCategoryRequest): Promise<CostCategoryDto> => {
    return await fetchPrivateApi<CostCategoryDto>(
      'POST',
      'cost-categories',
      dto,
    );
  },

  update: async (
    id: string,
    dto: CostCategoryRequest,
  ): Promise<CostCategoryDto> => {
    return await fetchPrivateApi<CostCategoryDto>(
      'PUT',
      `cost-categories/${id}`,
      dto,
    );
  },

  archive: async (id: string): Promise<CostCategoryDto> => {
    return await fetchPrivateApi<CostCategoryDto>(
      'POST',
      `cost-categories/${id}/archive`,
    );
  },

  unarchive: async (id: string): Promise<CostCategoryDto> => {
    return await fetchPrivateApi<CostCategoryDto>(
      'POST',
      `cost-categories/${id}/unarchive`,
    );
  },

  /** Zwraca kategorię docelową, źródłowa znika z listy razem z historią pod nową nazwą. */
  mergeInto: async (id: string, targetId: string): Promise<CostCategoryDto> => {
    return await fetchPrivateApi<CostCategoryDto>(
      'POST',
      `cost-categories/${id}/merge-into/${targetId}`,
    );
  },

  /** Twarde usunięcie — backend odmawia (400), gdy kategoria jest w użyciu. */
  remove: async (id: string): Promise<void> => {
    return await fetchPrivateApi<void>('DELETE', `cost-categories/${id}`);
  },
};

export default costCategoriesApi;
